import {
  ENROLL_PERSON_REQUEST_SET,
  ENROLL_PERSON_REQUEST_REMOVE,
} from './types';

export const removeEnrollPersonRequest = () => ({
  type: ENROLL_PERSON_REQUEST_REMOVE,
});

export const setEnrollPersonRequest = props => ({
  type: ENROLL_PERSON_REQUEST_SET,
  data: props,
});



// WEBPACK FOOTER //
// ./src/app/actions/enroll-person-request/index.js